import "./inputWithError.css";
import "./inputCustom.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class InputCustom extends Component {
  static propTypes = {
    field: PropTypes.array,
    actions: PropTypes.object
  };

  static defaultProps = {
    type: "text"
  };

  constructor(props) {
    super(props);

    this.timeoutTime = 300;
    this.timeout = null;
  }

  onChange = ({ target: { value } }) => {
    const { actions, feature, uid, field } = this.props;
    actions.setEntityField(feature, uid, field, value);
  };

  render() {
    const {
      uid,
      field,
      actions,
      entity,
      placeholder,
      disabled,
      type,
      onClick,
      feature,
      className
    } = this.props;

    return (
      <input
        type={type}
        id={uid}
        name={uid}
        className={className}
        onChange={this.onChange}
        placeholder={placeholder ? placeholder : null}
        value={entity !== undefined ? entity.getIn([].concat(field)) : ""}
        onClick={onClick}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/inputCustom.react.js